import { http } from '@/lib/http';
import type {
  FinishedGood,
  FinishedGoodInwardPayload,
  FinishedGoodScanInwardPayload,
  FinishedGoodStatus,
} from '@/types/finished-goods';

const BASE = '/api/v1/inventory/finished-goods';

export interface FinishedGoodListQuery {
  itemId?: string;
  warehouseId?: string;
  status?: FinishedGoodStatus;
  barcode?: string;
  page?: number;
  pageSize?: number;
}

interface FinishedGoodListResponse {
  rows: FinishedGood[];
  page: number;
  pageSize: number;
  total: number;
}

export interface InwardResult {
  inwardCount: number;
  finishedGoods: FinishedGood[];
}

export const finishedGoodsService = {
  list: (query: FinishedGoodListQuery = {}) =>
    http.get<FinishedGoodListResponse>(BASE, { params: query }),
  /** Lookup by barcode (the per-unit identifier). */
  getByBarcode: (barcode: string) =>
    http.get<FinishedGood>(`${BASE}/${encodeURIComponent(barcode)}`),
  /** Bulk inward — receive N units at once. */
  inward: (payload: FinishedGoodInwardPayload) =>
    http.post<InwardResult, FinishedGoodInwardPayload>(`${BASE}/inward`, payload),
  /** Single-scan inward — used at the wedge scanner. */
  scanInward: (payload: FinishedGoodScanInwardPayload) =>
    http.post<FinishedGood, FinishedGoodScanInwardPayload>(`${BASE}/scan-inward`, payload),
};
